import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReportRequest, IReturnSummaryByReason } from '../models/models'

export class GetOrderReportByReasonApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/returnReport/ReturnReportsByReason',
      requesterInfo,
    })
  }

  public async getReport(req: IReportRequest): Promise<IReturnSummaryByReason[]> {
    return await this.postAsync<IReturnSummaryByReason[]>(req)
  }
}
